import styled, { css } from 'styled-components';
const StyledInputContainer = styled.div `
  max-height: 36px;
  min-width: 36px;
  ${({ width }) => width && `width: ${width}px;`}
  display: flex;
  flex-direction: row;
  align-items: center;
  ${({ theme, inputDisabled }) => css `
    border: 1px solid ${inputDisabled ? theme.colors.grey30_2 : theme.colors.grey30_1};
    background-color: ${inputDisabled ? theme.colors.grey05_3 : theme.colors.grey00_7};
  `}
  border-radius: 8px;
  overflow: hidden;
  ${({ inputFocused, inputHovered, error, warning, success, theme }) => !inputFocused && inputHovered && !error && !warning && !success && `border: 1px solid ${theme.colors.grey70_1};`}
  ${({ inputFocused, warning, theme }) => warning &&
    css `
      ${inputFocused && theme.shadows.warning};
      border: 1px solid ${theme.colors.warning100};
    `}
  ${({ inputFocused, success, theme }) => success &&
    css `
      ${inputFocused && theme.shadows.success};
      border: 1px solid ${theme.colors.positive100};
    `}
  ${({ inputFocused, error, theme }) => error &&
    css `
      ${inputFocused && theme.shadows.error};
      border: 1px solid ${theme.colors.critical100};
    `}
  ${({ inputFocused, warning, success, error, theme }) => inputFocused &&
    !warning &&
    !success &&
    !error &&
    css `
      ${({ theme }) => theme.shadows.focus};
      border: 1px solid ${theme.colors.main};
    `}
`;
export default StyledInputContainer;
